import { Redirect } from 'expo-router'

/** See ./terms.tsx for context — same pattern. */
export default function ProfileCancellationRedirect() {
  return <Redirect href={'/legal/cancellation-policy' as never} />
}
